import { BalText } from "@baloise/ds-react";
import React from "react";
import { useTranslation } from "react-i18next";

import { BrokerContactCardProps } from "./brokerContactCard.types";
import * as style from "./brokercontactcard.module.scss";

/**
 * BrokerContactCard
 */

const BrokerContactCard: React.FC<BrokerContactCardProps> = ({
    phone,
    address,
    website,
    email,
    vat,
}) => {
    const { t } = useTranslation();

    const isBrokerDataEmpty = (value: string) => {
        return !value || value === "" || value === null;
    };

    return (
        <div className={style.brokercontactcard}>
            <ul>
                <li className={`lg-broker-phonenumber ${style.listitem}`}>
                    <BalText bold space="none">
                        {t("thankyou.brokercard.phone")}
                    </BalText>
                    <BalText space="none" className="mb-medium">
                        {isBrokerDataEmpty(phone) ? (
                            "-"
                        ) : (
                            <a
                                href={`tel:${phone}`}
                                className={style.listitemlink}
                            >
                                {phone}
                            </a>
                        )}
                    </BalText>
                </li>
                <li className={`lg-broker-address ${style.listitem}`}>
                    <BalText bold space="none">
                        {t("thankyou.brokercard.address")}
                    </BalText>
                    <BalText space="none" className="mb-medium">
                        {isBrokerDataEmpty(address) ? (
                            "-"
                        ) : (
                            <a
                                target="_blank"
                                href={`https://maps.google.com/?q=${address}`}
                                rel="noreferrer"
                                className={style.listitemlink}
                            >
                                {address}
                            </a>
                        )}
                    </BalText>
                </li>
                <li className={`lg-broker-url ${style.listitem}`}>
                    <BalText bold space="none">
                        {t("thankyou.brokercard.site")}
                    </BalText>
                    <BalText space="none" className="mb-medium">
                        {isBrokerDataEmpty(website) ? (
                            "-"
                        ) : (
                            <a
                                className={style.listitemlink}
                                target="_blank"
                                href={website}
                                rel="noreferrer"
                            >
                                {website}
                            </a>
                        )}
                    </BalText>
                </li>
                <li className={`lg-broker-email ${style.listitem}`}>
                    <BalText bold space="none">
                        {t("thankyou.brokercard.email")}
                    </BalText>
                    <BalText space="none" className="mb-medium">
                        {isBrokerDataEmpty(email) ? (
                            "-"
                        ) : (
                            <a
                                className={style.listitemlink}
                                href={`mailto:${email}`}
                            >
                                {email}
                            </a>
                        )}
                    </BalText>
                </li>
                <li className={`lg-broker-vat ${style.listitem}`}>
                    <BalText bold space="none">
                        {t("thankyou.brokercard.kbo")}
                    </BalText>
                    <BalText space="none">
                        {isBrokerDataEmpty(vat) ? (
                            "-"
                        ) : (
                            <span className={style.listitemtext}>{vat}</span>
                        )}
                    </BalText>
                </li>
            </ul>
        </div>
    );
};

export default BrokerContactCard;
